import {
  hrService,
  IEmployeeUpdateProbationParams,
} from "../../../../../Api/Services/HRService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const employeeUpdateProbation = createServiceAsyncThunk<
  IBaseResponse,
  IEmployeeUpdateProbationParams
>(
  ACTION_NAMES.UPDATE_EMPLOYEE_PROBATION,
  ({ user_id, probation_remark, probation_status, extended_date }) =>
    hrService.updateEmployeeProbation({
      user_id,
      probation_remark,
      probation_status,
      extended_date,
    }),
  ERROR_MESSAGES.UPDATE_EMPLOYEE_PROBATION_FAILURE
);

export const employeeUpdateProbationSlice = createGenericSlice<
  IBaseResponse,
  IEmployeeUpdateProbationParams
>(SLICE_NAMES.UPDATE_EMPLOYEE_PROBATION_SLICE, employeeUpdateProbation);

export const {
  clearError: clearEmployeeUpdateProbationError,
  clearSuccessMessage: clearEmployeeUpdateProbationSuccess,
} = employeeUpdateProbationSlice.actions;

export default employeeUpdateProbationSlice.reducer;
